import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'antd'

import AppLayout from '@components/layout/AppLayout'
import ProtectedRoute from '@components/ProtectedRoute'
import Dashboard from '@pages/Dashboard'
import Trading from '@pages/Trading'
import ManualOrders from '@pages/ManualOrders'
import TradeHistory from '@pages/TradeHistory'
import Risk from '@pages/Risk'
import RiskConfig from '@pages/RiskConfig'
import DynamicRiskRules from '@pages/DynamicRiskRules'
import Tokens from '@pages/Tokens'
import TokenOrders from '@pages/TokenOrders'
import Analytics from '@pages/Analytics'
import CfdStats from '@pages/CfdStats'
import Logs from '@pages/Logs'
import Alerts from '@pages/Alerts'
import FixedSettings from '@pages/FixedSettings'
import Reports from '@pages/Reports'
import Login from '@pages/Login'
import PanelLogin from '@pages/PanelLogin'

const { Content } = Layout

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* 登录页面 */}
        <Route path="/login" element={<Login />} />
        {/* Per-token 面板登录（公开） */}
        <Route path="/panel-login" element={<PanelLogin />} />
        <Route path="/panel-login/:id" element={<Navigate to="/panel-login" replace />} />
        {/* Per-token 订单管理面板（公开路由，页内做 admin/panel 鉴权守卫） */}
        <Route path="/tokens/:id/orders" element={<TokenOrders />} />
        {/* CFD 盈亏统计（接口无鉴权，公开路由，避免被路由守卫拦截） */}
        <Route path="/cfd-stats" element={<CfdStats />} />
        
        {/* 受保护的路由 */}
        <Route path="/*" element={
          <ProtectedRoute>
            <AppLayout>
              <Content style={{ padding: 0, margin: 0, minHeight: 280 }}>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/trading" element={<Trading />} />
                  <Route path="/manual-orders" element={<ManualOrders />} />
                  <Route path="/trade-history" element={<TradeHistory />} />
                  <Route path="/risk" element={<Risk />} />
                  <Route path="/risk-config" element={<RiskConfig />} />
                  <Route path="/dynamic-risk" element={<DynamicRiskRules />} />
                  <Route path="/tokens" element={<Tokens />} />
                  <Route path="/analytics" element={<Analytics />} />
                  <Route path="/logs" element={<Logs />} />
                  <Route path="/alerts" element={<Alerts />} />
                  <Route path="/settings" element={<FixedSettings />} />
                  <Route path="/reports" element={<Reports />} />
                </Routes>
              </Content>
            </AppLayout>
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  )
}

export default App
